import classNames from 'classnames'
import React from 'react'

import s from './Button.module.scss'
import { ButtonProps } from './Button.props'

export function Button({ variant = 'primary', children, onClick, className, type = 'button', ...props }: ButtonProps) {
  return (
    <button
      type={type}
      className={classNames(
        s.button,
        {
          [s.buttonOutline]: variant === 'outline',
          [s.buttonOpacity]: variant === 'opacity',
        },
        className,
      )}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  )
}
